<wiz-vgroup width="100%" height="100%" padding="0px" gap="0">
  <wiz-text-area
    #mainEdit
    width="100%"
    height="60px"
    (keyup)="checkCaret()"
    (click)="checkCaret()"
    [wizValue]="currentFormula"
  ></wiz-text-area>
  <!-- <div #descDiv spellcheck="false" width="100%" height="100%" class="formula-div" [innerHtml]="currentDescHtml" style="overflow-y: auto;"></div> -->
</wiz-vgroup>
